import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { MedalliaService } from '@core/medallia/services/medallia.service';
import { LoadMedalliaInfo } from '@core/medallia/store/actions/medallia.actions';

interface MedalliaStateModel {
  hashedEmail?: string;
}

@State<MedalliaStateModel>({
  name: 'medalliaInfo',
})
@Injectable()
export class MedalliaState {
  private readonly medalliaService = inject(MedalliaService);

  @Selector()
  static hashedEmail(state: MedalliaStateModel): string | undefined {
    return state.hashedEmail;
  }

  @Action(LoadMedalliaInfo, { cancelUncompleted: true })
  loadMedalliaInfo(context: StateContext<MedalliaStateModel>): Observable<string> {
    return this.medalliaService.getMedalliaInfo().pipe(tap(hashedEmail => context.patchState({ hashedEmail })));
  }
}
